// Client-side image processing. We downscale the data-plate photo before it
// ever leaves the phone: faster upload on garage wifi/cellular, and far fewer
// vision tokens on the Gemini call. A 1600px JPEG is plenty to read a sticker.

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file)
    const img = new Image()
    img.onload = () => {
      URL.revokeObjectURL(url)
      resolve(img)
    }
    img.onerror = (e) => {
      URL.revokeObjectURL(url)
      reject(e)
    }
    img.src = url
  })
}

function fitDimensions(w, h, maxDim) {
  if (w <= maxDim && h <= maxDim) return { width: w, height: h }
  const scale = maxDim / Math.max(w, h)
  return { width: Math.round(w * scale), height: Math.round(h * scale) }
}

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      // strip the "data:image/jpeg;base64," prefix — the API wants raw base64
      const result = String(reader.result)
      resolve(result.slice(result.indexOf(',') + 1))
    }
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}

/**
 * @returns {Promise<{blob: Blob, base64: string, previewUrl: string, width: number, height: number}>}
 */
export async function processImage(file, maxDim = 1600, quality = 0.82) {
  const img = await loadImage(file)
  const { width, height } = fitDimensions(img.naturalWidth, img.naturalHeight, maxDim)

  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext('2d')
  ctx.drawImage(img, 0, 0, width, height)

  const blob = await new Promise((resolve, reject) =>
    canvas.toBlob(
      (b) => (b ? resolve(b) : reject(new Error('Image encoding failed'))),
      'image/jpeg',
      quality,
    ),
  )

  const base64 = await blobToBase64(blob)
  const previewUrl = URL.createObjectURL(blob)
  return { blob, base64, previewUrl, width, height }
}
